import { Phone } from "lucide-react";
import { BUSINESS } from "../data/site";
import { useRequestModal } from "./RequestModal";
import { track } from "../lib/api";

export default function MobileBottomBar() {
  const { openRequest } = useRequestModal();
  return (
    <div className="fixed bottom-0 inset-x-0 z-50 md:hidden bg-ink border-t border-slate-800 p-3 pb-[max(0.75rem,env(safe-area-inset-bottom))] shadow-2xl" data-testid="mobile-bottom-bar">
      <div className="grid grid-cols-2 gap-3">
        <a
          href={BUSINESS.phoneHref}
          onClick={() => track("click_to_call", { location: "mobile_bottom_bar" })}
          className="flex items-center justify-center gap-2 py-3 rounded-lg border border-slate-600 text-white font-heading font-semibold text-sm active:scale-[0.98] transition-transform"
          data-testid="bottom-bar-call"
        >
          <Phone className="h-4 w-4" /> Call Now
        </a>
        <button
          onClick={() => openRequest()}
          className="py-3 rounded-lg bg-sky-600 text-white font-heading font-semibold text-sm active:scale-[0.98] transition-transform"
          data-testid="bottom-bar-request"
        >
          Request a Dumpster
        </button>
      </div>
    </div>
  );
}
